module.exports = __webpack_public_path__ + "static/media/ma.7ccf0a17.svg";